Ext.define('SA.view.VariablePathRenderer', {
    singleton: true,

    render({cls, path}) {
        var folders = path && Ext.util.Format.htmlEncode(path).split(' » ');

        if (!path) {
            return Ext.DomHelper.createHtml({tag: 'span', cls, html: '\u00a0'});
        }

        return getSpanRecursive(folders);

        function getSpanRecursive(folders) {
            var path = folders.join(' » '),
                getSpan = ({innerHtml: html}) => Ext.DomHelper.createHtml({tag: 'span', cls, 'data-path': path, html});

            if (folders.length === 1) {
                return getSpan({innerHtml: folders[0]});
            }
            else {
                let lastFolder = folders.pop(),
                    htmlForAllButLastFolder = getSpanRecursive(folders);

                return getSpan({innerHtml: `${htmlForAllButLastFolder} » ${lastFolder}`});
            }
        }
    }
});